import React from "react";
import { Wand as WandIcon } from "@/components/ds/icons";
import { PrimaryButton } from "@/components/ds";

/**
 * Standard "Launch Starter Wizard" button — use this everywhere a StarterWorkflowWizard
 * can be launched. Keeps the style consistent across all integration and channel pages.
 *
 * Usage:
 *   <LaunchWizardButton onClick={() => setShowWizard(true)} />
 *   <LaunchWizardButton onClick={() => setShowWizard(true)} disabled={!hasConfig} />
 *   <LaunchWizardButton onClick={() => setShowWizard(true)} label="Set Up Workflows" />
 */
interface LaunchWizardButtonProps {
  onClick(): void;
  disabled?: boolean;
  label?: string;
  size?: "sm" | "md";
}

export default function LaunchWizardButton({
  onClick,
  disabled = false,
  label = "Launch Starter Wizard",
  size = "md"
}: LaunchWizardButtonProps) {
  const sizeClasses = size === "sm" ? "!text-xs !px-3 !py-1.5" : "";

  return (
    <PrimaryButton
      onClick={onClick}
      disabled={disabled}
      className={`${sizeClasses} whitespace-nowrap shadow-sm`}
      prefixIcon={<WandIcon className="w-3.5 h-3.5 opacity-80 inline-block align-middle" />}
    >
      {label}
    </PrimaryButton>
  );
}
